/* 
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {CRUDPermissions, GenericObject} from '@ion/core/src/types/entities';
import {adminDevicesViewIsEditingSelector, viewDevicesShowDialogSelector} from './state-selectors';
import ViewDeviceEditor, {ViewDeviceEditorProps} from './ViewDeviceEditor';

export interface ViewDeviceOptions extends Omit<ViewDeviceDialogProps, 'includeEditAction'> {
  includeEditActionInViewDialog?: boolean;
}

export interface ViewDeviceDialogProps extends ViewDeviceEditorProps {
  enableViewDialog?: boolean;
  selectedJobId?: (jobId: number) => void;
  isToggleSwitchGrid?: boolean;
  isShowColumnChooserIcon?: boolean;
  isShowRefreshButton?: boolean;
  devicesPermissions?: CRUDPermissions;
  hasCreateJob?: boolean;
  isCtcAdmin?: boolean;
  Features?: GenericObject;
}

/**
 * Holds dialog functionality for viewing a device.
 */
export const ViewDeviceDialog = ({
  selectedJobId,
  devicesPermissions,
  hasCreateJob,
  Features,
  explicitReportDate = false,
  includeEditAction = false,
  refreshDevice = false,
  enableViewDialog = false,
  isVbuFwEnabled = false,
  isToggleSwitchGrid = false,
  isShowColumnChooserIcon = false,
  isCtcAdmin = false,
  isShowRefreshButton = true
}: ViewDeviceDialogProps) => {
  const showViewDevice      = useSelector(adminDevicesViewIsEditingSelector);
  const showViewBulkDevices = useSelector(viewDevicesShowDialogSelector);
  
  return (
    <>
      {showViewDevice && enableViewDialog && !showViewBulkDevices && (
        <ViewDeviceEditor refreshDevice={refreshDevice}
          devicesPermissions={devicesPermissions}
          Features={Features}
          hasCreateJob={hasCreateJob}
          isVbuFwEnabled={isVbuFwEnabled}
          selectedJobId={selectedJobId}
          includeEditAction={includeEditAction}
          explicitReportDate={explicitReportDate}
          isToggleSwitchGrid={isToggleSwitchGrid}
          isShowColumnChooserIcon={isShowColumnChooserIcon}
          isCtcAdmin={isCtcAdmin}
          isShowRefreshButton={isShowRefreshButton} />
      )}
    </>
  );
};

export default memo(ViewDeviceDialog);
